module.exports = __webpack_public_path__ + "img/cancel.0f845c95.svg";